import styled from 'styled-components';
import { IC_BOOKMARK_CHECKED, IC_BOOKMARK_GREY, IC_BOOKMARK } from '../../Assets/images';

export const DoctorCardStyled = styled.div`
  width: 100%;
  overflow: auto;

  .cursor-pointer {
    cursor: pointer;
  }

  .clinicDetailCard {
    margin: 0px 7.5px;
  }
  
  .facilityAsterIconWrapper{
    display: flex;
    justify-content: space-between;
  }

  .addToWishList {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background: ${(props) => props.theme.color.white};
    box-shadow: ${(props) => (props?.isShareable ? '0 3px 7px rgba(33, 57, 79, 0.08)' : 'none')};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0px 5px 0px 0px;
    margin-left: auto;
    .form-check-input[type='checkbox'] {
      width: 16px;
      height: 20px;
      background: url(${(props) => (!props?.isShareable ? IC_BOOKMARK.src : IC_BOOKMARK_GREY.src)}) no-repeat;
      border-radius: 50%;
      background-size: 100%;
      border: 0;
      margin: 10px 7px 10px 7px;
      cursor: pointer;
      border-radius: 2px;

      &:focus {
        box-shadow: 0 0 0;
      }

      &:checked {
        background: url(${IC_BOOKMARK_CHECKED.src}) no-repeat;
      }
    }
  }
  .share-icon {
    cursor: pointer;
  }
  .doctorcard{
    padding: 0px 16px 16px 16px !important;
  }

  .doctorCardWrapper {
    padding: 16px;

    .detailWrapper {
      display: flex;

      .doctorImage {
        width: 110px;
        height: 110px;
        min-width: 110px;
        margin-right: 20px;
        background-color: ${(props) => props.theme.blue.iconBg};
        overflow: hidden;
        border-radius: 50%;
        margin-bottom: 10px;
        margin-left: 13px;

        img {
          border-radius: 50%;
          object-fit: contain;
        }
      }
      .doctorDetail {
        flex-grow: 1;
        max-width: calc(100% - 130px);
        width: 100%;

        .doctorName {
          font-weight: 700;
          font-size: 16px;
          line-height: 20px;
          color: ${(props) => props.theme.text.dark};
          margin-bottom: 2px;
          display: flex;
          height: 20px;

          .name {
            white-space: nowrap;
            max-width: calc(100% - 25px);
            overflow: hidden;
            text-overflow: ellipsis;
            flex-grow: 1;

            &.greyText {
              color: ${(props) => props.theme.grey.dark};
              .highlight {
                color: ${(props) => props.theme.text.dark};
              }
            }
          }
        }
        .doctorSpecialty {
          font-weight: 600;
          font-size: 14px;
          line-height: 18px;
          color: ${(props) => props.theme.text.medium};
          margin-bottom: 4px;
          .highlight {
            color: ${(props) => props.theme.text.dark};
            font-weight: 700;
          }
        }
        .languageKnown {
          font-weight: 600;
          font-size: 12px;
          line-height: 15px;
          color: ${(props) => props.theme.text.darkest};
          margin-bottom: 8px;
          white-space: nowrap;
          max-width: calc(100% - 25px);
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .doctorAddress {
          display: flex;
          align-items: center;
          width: 100%;
          overflow: hidden;

          .address,
          .distance {
            font-weight: 600;
            font-size: 14px;
            line-height: 18px;
            color: ${(props) => props.theme.text.dark};
            white-space: nowrap;
          }
          .address {
            max-width: calc(100% - 163px);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .locationIcon {
            margin-right: 2px;
            min-width: 21px;
            > div {
              display: block !important;
            }
          }
          .more {
            font-weight: 700;
            font-size: 15px;
            line-height: 19px;
            color: ${(props) => props.theme.text.medium};
            cursor: pointer;
            margin-left: 16px;
            white-space: nowrap;
          }
        }
      }
    }

    .Outside {
      &.doctorAddress {
        display: flex;
        align-items: flex-start;
        width: 100%;
        overflow: hidden;
        margin-top: 16px;

        .clinicAddress {
          max-width: calc(100% - 95px);
          flex-grow: 1;
        }

        .distance {
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          color: ${(props) => props.theme.grey.dark};
          white-space: nowrap;
        }
        .address {
          font-weight: 600;
          font-size: 15px;
          line-height: 19px;
          color: ${(props) => props.theme.text.dark};
          max-width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-bottom: 2px;
        }
        .locationIcon {
          margin-right: 2px;
          min-width: 21px;
          > div {
            display: block !important;
          }
        }
        .more {
          font-weight: 700;
          font-size: 15px;
          line-height: 19px;
          color: ${(props) => props.theme.text.medium};
          cursor: pointer;
          margin-left: 16px;
          white-space: nowrap;
        }
      }
    }
    .bottomLine {
      background-color: ${(props) => props.theme.color.divider};
      opacity: 1;
    }
    .viewMoreBlock {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 600;
      font-size: 15px;
      line-height: 19px;
      color: ${(props) => props.theme.text.dark};

      .viewMore {
        font-weight: 700;
        font-size: 15px;
        line-height: 19px;
        color: ${(props) => props.theme.blue.dark};
        text-decoration: capitalize;
        cursor: pointer;
      }
    }
    .appointmentType {
      display: flex;
      gap: 15px;
      margin-top: 16px;

      .box {
        display: flex;
        align-items: center;
        padding: 11px 24px 11px 14px;
        border-radius: 8px;
        cursor: pointer;

        .consultIcon {
          margin-right: 12px;
          > div {
            display: block !important;
          }
        }
        .consultTitle {
          font-weight: 600;
          font-size: 12px;
          line-height: 15px;
          color: ${(props) => props.theme.grey.dark};
          margin-bottom: 1px;
        }
        .consultTime {
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
        }
        &.blueBox {
          background: ${(props) => props.theme.blue.iconBg};
          .consultTime {
            color: ${(props) => props.theme.blue.dark};
          }
          &.gpHeight {
            min-height: 56px;
          }
        }
        &.greenBox {
          background: ${(props) => props.theme.green.extraLight};
          .consultTime {
            color: ${(props) => props.theme.green.dark};
          }
        }
        &.greyBox {
          background: ${(props) => props.theme.blue.mild};
          min-height: 56px;
          .consultTime {
            font-weight: 700;
            font-size: 15px;
            line-height: 19px;
            color: ${(props) => props.theme.grey.dark};
          }
        }
        .viewBtn {
          cursor: pointer;
        }
      }
    }
  }

  &.doctorDetailCard {
    .doctorCardWrapper {
      .detailWrapper {
        position: relative;
        align-items: center;

        .doctorImage {
          margin-bottom: 0;
        }
        .doctorDetail {
          .actionBlock {
            position: absolute;
            z-index: 1;
            top: 0;
            right: 0;

            .share {
              display: flex;

              .share-tost {
                width: 40px;
                height: 40px;
                border-radius: 20px;
                background: ${(props) => props.theme.color.white};
                box-shadow: rgba(33, 57, 79, 0.08) 0px 3px 7px;
                top: 10px;
                right: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                margin-left: 5px;

                .filter {
                  width: 18px;
                  height: 20px;

                  .ic {
                    width: 18px;
                    height: 20px;
                  }

                  .filterBox {
                    min-width: 198px;
                    text-align: left;
                    background: ${(props) => props?.theme?.color?.white};
                    border: 1px solid ${(props) => props?.theme?.color?.borderLight};
                    padding: 16px 14px;
                    position: absolute;
                    top: calc(100% + 10px);
                    right: -10px;
                    border-radius: 4px;
                    z-index: 2;

                    .box {
                      margin: 0 0 16px 0;

                      .title {
                        font-size: 15px;
                        font-weight: 600;

                        .react-share__ShareButton {
                          width: 100%;
                          display: flex;
                          flex-direction: row;
                          align-items: center;

                          > div {
                            width: 36px;
                            height: 36px;
                            margin-right: 10px !important;
                            position: relative;
                          }
                        }
                      }

                      &:last-child {
                        margin: 0;
                      }
                    }

                    &.openUp {
                      top: auto;
                      bottom: calc(100% + 20px);

                      &::before {
                        top: auto;
                        bottom: -9px;
                        transform: rotate(180deg);
                      }

                      &::after {
                        top: auto;
                        bottom: -8px;
                        transform: rotate(180deg);
                      }
                    }

                    &:before,
                    &:after {
                      content: '';
                      width: 12px;
                      height: 8px;
                      position: absolute;
                      border-top: 0;
                    }
                    &:after {
                      top: -8px;
                      right: 20px;
                      border-bottom: 8px solid ${(props) => props.theme.color.white};
                      border-right: 8px solid transparent;
                      border-left: 8px solid transparent;
                    }
                    &:before {
                      top: -10px;
                      right: 19px;
                      border-bottom: 9px solid ${(props) => props.theme.color.border};
                      border-right: 9px solid transparent;
                      border-left: 9px solid transparent;
                    }
                  }
                }
              }
            }
          }
          .bottomLine {
            display: none !important;
          }
        }
      }
      .appointmentType {
        display: none;
      }
    }
  }
  &.sideBardoctorDetailCard {
    .card {
      border: 0;
      border-radius: 0;
    }
    .doctorCardWrapper {
      padding: 24px 16px 20px;

      .detailWrapper {
        position: relative;
        align-items: center;

        .doctorImage {
          margin-bottom: 0;
          width: 80px;
          height: 80px;
          min-width: 80px;
        }
        .doctorDetail {
          max-width: calc(100% - 100px);
          .doctorName {
            .name {
              max-width: 100%;
            }
            margin-bottom: 6px;
          }
          .doctorSpecialty {
            margin-bottom: 6px;
          }
          .languageKnown {
            max-width: 100%;
            font-weight: 600;
            font-size: 14px;
            line-height: 18px;
            margin-bottom: 0;
          }
          .actionBlock {
            display: none;
          }
          .bottomLine {
            display: none !important;
          }
        }
      }
      .appointmentType,
      .bottomLine {
        display: none !important;
      }
    }
  }
  &.doctorDetailCentered {
    .doctorCardWrapper {
      .detailWrapper {
        align-items: center;
        position: relative;

        .doctorImage {
          width: 70px;
          min-width: 70px;
          height: 70px;
        }
        .doctorDetail {
          max-width: calc(100% - 115px);

          .doctorName {
            font-size: 17px;
            .name {
              max-width: 100%;
            }
          }
          .actionBlock {
            position: absolute;
            z-index: 1;
            top: 0;
            right: 0;
          }
          .languageKnown {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .message {
    font-weight: 700;
    font-size: 12px;
    line-height: 19px;
    color: ${(props) => props.theme.grey.dark};
    margin-bottom: 1px;
  }
  .min-height-39 {
    min-height: 39px;
    font-weight: 500;
  }

  @media (max-width: 780px) {
    .doctorCardWrapper {
      padding-top: 0px !important;
    }
    .responsiveIcon {
      display: flex;
      flex-direction: row;

      .notIcons {
        margin-left: auto !important;
      }

      .rightSideShare {
        display: flex;
        flex-direction: row;
        margin-left: 120px;

        .addToWishList {
          margin-top: 5px;
        }

        .share {
          display: flex;
          margin-right: 10px;

          .share-tost {
            width: 40px;
            height: 40px;
            border-radius: 20px;
            background: ${(props) => props.theme.color.white};
            box-shadow: rgba(33, 57, 79, 0.08) 0px 3px 7px;
            top: 10px;
            right: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-left: 5px;
            margin-top: 5px;

            .filter {
              width: 18px;
              height: 20px;

              .ic {
                width: 18px;
                height: 20px;
              }

              .filterBox {
                min-width: 198px;
                text-align: left;
                background: ${(props) => props?.theme?.color?.white};
                border: 1px solid ${(props) => props?.theme?.color?.borderLight};
                padding: 16px 14px;
                position: absolute;
                top: 56px;
                right: 5px;
                border-radius: 4px;
                z-index: 2;

                .box {
                  margin: 0 0 16px 0;

                  .title {
                    font-size: 15px;
                    font-weight: 600;

                    .react-share__ShareButton {
                      width: 100%;
                      display: flex;
                      flex-direction: row;
                      align-items: center;

                      > div {
                        width: 36px;
                        height: 36px;
                        margin-right: 10px !important;
                        position: relative;
                      }
                    }
                  }

                  &:last-child {
                    margin: 0;
                  }
                }

                &.openUp {
                  top: auto;
                  bottom: calc(100% + 20px);

                  &::before {
                    top: auto;
                    bottom: -9px;
                    transform: rotate(180deg);
                  }

                  &::after {
                    top: auto;
                    bottom: -8px;
                    transform: rotate(180deg);
                  }
                }

                &:before,
                &:after {
                  content: '';
                  width: 12px;
                  height: 8px;
                  position: absolute;
                  border-top: 0;
                }
                &:after {
                  top: -8px;
                  right: 20px;
                  border-bottom: 8px solid ${(props) => props.theme.color.white};
                  border-right: 8px solid transparent;
                  border-left: 8px solid transparent;
                }
                &:before {
                  top: -10px;
                  right: 19px;
                  border-bottom: 9px solid ${(props) => props.theme.color.border};
                  border-right: 9px solid transparent;
                  border-left: 9px solid transparent;
                }
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 575px) and (min-width: 424px) {
    .responsiveIcon {
      .rightSideShare {
        margin-left: 156px;
      }
    }
    .doctorCardWrapper{
      .doctorDetailresponsive{
        .doctorImage{
          margin-left: 0px;
        }
        .doctorDetail{
          .doctorName{
            width:190px;
          }
        }
      }
    }
  }

  @media (min-width: 576px) and (max-width: 780px) {
    .responsiveIcon {
      .rightSideShare {
        margin-left: 120px;
      }
    }
    .doctorCardWrapper{
      .doctorDetailresponsive{
        .doctorImage{
          margin-left: 0px;
        }
        .doctorDetail{
          .doctorName{
            width:170px;
          }
        }
      }
    }
  }

  @media (min-width: 374px) and (max-width: 410px) {
    .doctorCardWrapper {
      padding-top: 0px !important;
    }
    .responsiveIcon {
      display: flex;
      flex-direction: row;
      .rightSideShare {
        margin-left: 110px;
      }
    }
    .doctorCardWrapper{
      .doctorDetailresponsive{
        .doctorImage{
          margin-left: 0px;
        }
        .doctorDetail{
          .doctorName{
            width:160px;
          }
        }
      }
    }
  }

  @media (min-width: 319px) and (max-width: 373px) {
    .doctorCardWrapper {
      padding-top: 0px !important;
    }
    .responsiveIcon {
      display: flex;
      flex-direction: row;
      .rightSideShare {
        margin-left: 50px;
      }
    }
    .doctorCardWrapper{
      .doctorDetailresponsive{
        .doctorImage{
          margin-left: 0px;
        }
        .doctorDetail{
          .doctorName{
            width:137px;
          }
        }
      }
    }
  }

  @media (max-width: 991px) {
    .doctorCardWrapper {
      .detailWrapper {
        .doctorImage {
          width: 70px;
          min-width: 70px;
          height: 70px;
          margin-right: 12px;
          margin-bottom: 0;
        }
        .doctorDetail {
          max-width: calc(100% - 82px);

          .doctorAddress {
            width: 100%;
            overflow: auto;
            flex-wrap: wrap;
            .address {
              max-width: calc(100% - 116px);
            }
            .more {
              flex-basis: 100%;
              margin-left: 23px;
            }
          }
          .languageKnown {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: 100%;
            margin-bottom: 8px;
          }
        }
      }
      .appointmentType {
        flex-direction: column;
      }
    }

    &.doctorDetailCard {
      .doctorCardWrapper {
        .bottomLine {
          display: none !important;
        }
      }
    }
  }
`;
